module.exports = __webpack_public_path__ + "img/anugerah3.60632e49.jpg";